// extracted by mini-css-extract-plugin
module.exports = {"nodatInternal":"no-data-table_nodatInternal__3hN-q","nodataTitle":"no-data-table_nodataTitle__3o9ZU","nodataText":"no-data-table_nodataText__22wnU"};